import { Box, Text } from '@factorialco/deprecated-design-system'
import { ShiftManagementRolesRequirementsFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { StaffRequirements } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/CoverageSection/Body/StaffRequirements'
import ShiftAccessSelectors from 'modules/shift_management/components/ShiftManagement/ShiftAccessSelectors'
import ShiftLocationPicker from 'modules/shift_management/components/ShiftManagement/ShiftLocationPicker'
import ShiftNotesField from 'modules/shift_management/components/ShiftManagement/ShiftNotesField'
import ShiftOvertimeCheckbox from 'modules/shift_management/components/ShiftManagement/ShiftOvertimeCheckbox'
import ShiftTimePicker from 'modules/shift_management/components/ShiftManagement/ShiftTimePicker'
import type UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

interface Props {
  unassignedShiftForm: UnassignedShiftForm
  totalAssignedShifts: number
  roles: ShiftManagementRolesRequirementsFragment[]
}

const Content = ({ unassignedShiftForm, totalAssignedShifts, roles }: Props) => {
  const originalCounter = unassignedShiftForm.get('counter').value
  const minCounter = originalCounter - totalAssignedShifts === 0 ? originalCounter : 1

  return (
    <Box flexDirection="column" gap="s24">
      <Box gap="s8">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Text.Normal size="200" color="grey1000" weight="medium">
            {i18n.t('shift_management.coverage_section.unassigned_shift.staff_requirements.title')}
          </Text.Normal>
        </Box>
        <StaffRequirements form={unassignedShiftForm} id={0} min={minCounter} roles={roles} />
      </Box>
      <Box gap="s8">
        <ShiftTimePicker
          startField={unassignedShiftForm.get('start_at')}
          endField={unassignedShiftForm.get('end_at')}
        />
        <ShiftOvertimeCheckbox form={unassignedShiftForm} />
      </Box>
      <Box gap="s8">
        <ShiftLocationPicker
          locationField={unassignedShiftForm.get('location_id')}
          workAreaField={unassignedShiftForm.get('work_area_id')}
        />
      </Box>
      <Box gap="s8">
        <ShiftNotesField notesField={unassignedShiftForm.get('notes')} />
      </Box>
      <Box gap="s8">
        <ShiftAccessSelectors form={unassignedShiftForm} />
      </Box>
    </Box>
  )
}

export default observer(Content)
